// Shared WhatsApp link helpers. Use these instead of building wa.me URLs by hand.

// iPadOS reports a desktop Mac user agent, so also treat touch-capable Macs as mobile
export const isMobileDevice = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    return /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
};

/**
 * Convert a phone number to the international digits WhatsApp expects.
 * 0712345678, +254 712 345 678, 254712345678 and 712345678 all become 254712345678.
 * Numbers that are not Kenyan-shaped are returned as plain digits. Returns '' if there are no digits.
 */
export const toWhatsappNumber = (phone) => {
    const digits = String(phone ?? '').replace(/\D/g, '');
    if (/^0[17]\d{8}$/.test(digits)) return `254${digits.slice(1)}`;
    if (/^[17]\d{8}$/.test(digits)) return `254${digits}`;
    return digits;
};

/**
 * Build a WhatsApp chat link. Mobile opens the app via wa.me; desktop opens WhatsApp Web,
 * because the desktop app often drops the chat from wa.me links when it has to launch cold.
 * With no phone, the link opens WhatsApp with the message ready to send to any contact.
 */
export const whatsappUrl = (phone, text) => {
    const number = toWhatsappNumber(phone);
    const query = text ? `text=${encodeURIComponent(text)}` : '';

    if (isMobileDevice()) {
        return `https://wa.me/${number}${query ? `?${query}` : ''}`;
    }
    const params = [number && `phone=${number}`, query].filter(Boolean).join('&');
    return `https://web.whatsapp.com/send${params ? `?${params}` : ''}`;
};

export const openWhatsapp = (phone, text) => {
    window.open(whatsappUrl(phone, text), '_blank', 'noopener,noreferrer');
};
